import "../styles/globals.css";
import "../styles/PronAnalysisSection.css";
import "../styles/interviews/Review_NavBar.css";
import "../styles/interviews/Review_Panel_AntiCheat.css";
import "../styles/interviews/Review_Panel_Assessment.css";
import "../styles/interviews/Review_Panel_Performance.css";
import "../styles/interviews/Review_Panel_PronAssess.css";
import "../styles/interviews/Review_Panel_TalkPoints.css";
import "video.js/dist/video-js.css";
import "../styles/candidates/HSLabel.css";
import "../styles/interviews/Review_Panel_Video.css";
import "../styles/interviews/TalkingPointsSection.css";
import "../styles/interviews/main.css";
import "../styles/login.css";
import "../styles/base.css";

import { NextPage, NextComponentType, NextPageContext } from "next";
// import { FpjsProvider } from "@fingerprintjs/fingerprintjs-pro-react";

import Head from "next/head";
import { AppProps } from "next/app";
import { AuthProvider } from "@/hooks/useAuth";
// import { TablaProvider } from "@/lib/Tabla";
import { useEffect, useRef } from "react";
import { usePrivacyStore } from "@/store/usePrivacyStore";
import { useRouter } from "next/router";
import { useAuthStore } from "@/store/useAuthStore";
import { Toaster } from "react-hot-toast";

type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  needAuth: boolean;
};

export type NextComponentWithLayout = NextComponentType<
  NextPageContext,
  any,
  {}
> &
  Partial<NextPageWithLayout>;

type ExtendedAppProps<P = {}> = AppProps<P> & {
  Component: NextComponentWithLayout;
  pageProps: any;
};

function MyApp({ Component, pageProps }: ExtendedAppProps) {
  const { needAuth = true } = Component;

  const router = useRouter();
  // ==============================================
  // User Fetch on every load
  // ==============================================
  const fetchUser = useAuthStore((s) => s.fetchUser);
  const hasFetched = useRef(false);

  useEffect(() => {
    console.log("needAuth", needAuth);
    if (needAuth && !hasFetched.current && router.isReady) {
      fetchUser(router);
      hasFetched.current = true;
    }
  }, [needAuth, router]);
  // ==============================================

  const setPrivacyModeEnabled = usePrivacyStore(
    (state) => state.setPrivacyModeEnabled
  );
  const setPrivacyModeState = usePrivacyStore(
    (state) => state.setPrivacyModeState
  );

  useEffect(() => {
    const enforcePrivacyHash = (privacy: boolean) => {
      const currentHash = window.location.hash;
      if (privacy) {
        // Append #privacy hash if not already present
        if (!currentHash.includes("#privacy")) {
          const newHash = currentHash ? `${currentHash}#privacy` : "#privacy"; // Append to existing hash or start with #privacy
          history.replaceState(
            null,
            "",
            `${window.location.pathname}${newHash}`
          );
        }
      } else {
        // Remove only the #privacy hash
        if (currentHash.includes("#privacy")) {
          const newHash = currentHash
            .split("#")
            .filter((hash) => hash !== "privacy") // Remove #privacy
            .filter((hash) => hash !== "privacyOff") // Remove #privacyOff
            .join("#"); // Reconstruct the hash string
          history.replaceState(
            null,
            "",
            `${window.location.pathname}${newHash ? `#${newHash}` : ""}`
          );
        }
      }
    };

    const checkPrivacyMode = () => {
      // Button to disable privacy mode
      const isPrivacyModeDisabled =
        window.location.hash.includes("#privacyOff") ||
        sessionStorage.getItem("privacyModeEnabled") === "false";
      console.log(`Has no privacy mode disabled: ${isPrivacyModeDisabled}`);
      if (isPrivacyModeDisabled) {
        sessionStorage.removeItem("privacyModeEnabled");
        // Force clear off privacy mode on storage
        sessionStorage.removeItem("privacyModeOn");
        setPrivacyModeEnabled(false);
        setPrivacyModeState(false);
        enforcePrivacyHash(false);
      }

      // Button to enable privacy mode
      const isPrivacyModeEnabled =
        window.location.hash.includes("#privacy") ||
        sessionStorage.getItem("privacyModeEnabled") === "true";
      console.log(`Has privacy mode enabled: ${isPrivacyModeEnabled}`);
      if (isPrivacyModeEnabled) {
        sessionStorage.setItem("privacyModeEnabled", "true");
        setPrivacyModeEnabled(true);
        enforcePrivacyHash(true);
      }
      // Recover previous state of privacy mode
      const isPrivacyModeOn =
        sessionStorage.getItem("privacyModeOn") === "true";
      console.log(`Has privacy mode on: ${isPrivacyModeOn}`);
      if (isPrivacyModeOn) {
        // If mode on, the privacy mode must be enabled
        if (!isPrivacyModeEnabled) {
          sessionStorage.setItem("privacyModeEnabled", "true");
          setPrivacyModeEnabled(true);
          enforcePrivacyHash(true);
        }
        setPrivacyModeState(true);
      }
    };

    // Check on page load
    checkPrivacyMode();

    // Optional: Listen to hash changes
    window.addEventListener("hashchange", checkPrivacyMode);

    return () => {
      window.removeEventListener("hashchange", checkPrivacyMode);
    };
  }, [setPrivacyModeEnabled, router.query]);

  return (
    // <FpjsProvider
    //   loadOptions={{
    //     apiKey: "AyU2JdvVuX6jxTxdsTz1",
    //     region: "ap",
    //   }}
    // >
    <>
      {needAuth === false ? (
        <>
          {/* <AuthProvider disablePreAuth={true}>         */}
          {/* <TablaProvider> */}
          <Head>
            <title> Dashboard | HKU | powered by Career Hackers</title>
          </Head>
          <Component {...pageProps} />
          {/* </TablaProvider> */}
          {/* </AuthProvider> */}
        </>
      ) : (
        <>
          {/* <AuthProvider disablePreAuth={false}> */}
          {/* <TablaProvider> */}
          <Head>
            <title> Dashboard | HKU | powered by Career Hackers</title>
          </Head>
          <Component {...pageProps} />
          {/* </TablaProvider> */}
          {/* </AuthProvider> */}
        </>
      )}
      <Toaster position="top-right" />
    </>
    // </FpjsProvider>
  );
}

export default MyApp;
